import { FC } from 'react';
import { TransportSelectionContext } from './TransportSelectionContext';
import { AuthenticationContext } from './AuthenticationContext';
import { type FormContext as Context } from '../../../types/session';
import { TwoFactorAuthMethodSelectionContext } from './2FAMethodSelectionContext';
import { TwoFactorAuthInputContext } from './2FAInputContext';
import { TwoFactorAuthPendingContext } from './2FAPendingContext';

interface Props {
	context: Context;
}

export const FormContext: FC<Props> = ({ context }) => {
	switch (context) {
		case 'authentication':
		case 'auth:credentials':
			return <AuthenticationContext />;
		case 'transport_selection':
			return <TransportSelectionContext />;
		case '2FA:selection':
			return <TwoFactorAuthMethodSelectionContext />;
		case '2FA:input':
			return <TwoFactorAuthInputContext />;
		case '2FA:pending':
			return <TwoFactorAuthPendingContext />;
		default:
			return null;
	}
};
